// Star DFDG valideringsmatrice: https://starwiki.atlassian.net/wiki/spaces/LOG/pages/3810230303/Lovlige+bevillingsrammer+for+kurser+i+forhold+til+kursets+afholdelseskategorier
export function getAllowedCourseTypes(courseAllocation: number | undefined): string[] {
  switch (courseAllocation) {
    case 25:
    case 30:
    case 36:
    case 40:
    case 41:
    case 45:
      return ['11', '5', '15', '18'];
    case 26:
    case 29:
    case 47:
      return ['11', '5', '7', '15', '18'];
    case 27:
    case 28:
      return ['11', '5', '6', '7', '15', '17', '18'];
    case 34:
    case 35:
    case 42:
    case 43:
      return ['11', '15'];
    case 37:
      return ['11', '5', '15'];
    case 38:
      return ['9'];
    case 39:
      return ['11', '15', '18'];
    case 44:
    case 48:
    case 49:
      return ['11'];
    case 46:
      return ['11', '18'];
    case 50:
    case 51:
      return ['14'];
    case 52:
      return ['16'];
    case 53:
      return ['19'];
    default:
      return [];
  }
}
